$(function () {
    'use strict';

    $('.related-entries--thumbs').on('scrollin', lazyLoadImages);

    function lazyLoadImages() {
        // jshint validthis:true
        var $container = $(this);
        $container.off('scrollin', lazyLoadImages);
        $container.find('.related-entries__image').each(function () {
            this.querySelector('img').src = this.getAttribute('data-img-src');
        });
    }
});
